import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
var QuestantRedirectComponent = /** @class */ (function () {
    function QuestantRedirectComponent(_activatedRoute) {
        this._activatedRoute = _activatedRoute;
    }
    QuestantRedirectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._activatedRoute.queryParams.subscribe(function (params) {
            var notificationId = Number(params.notificationId);
            if (notificationId) {
                // アプリお知らせ詳細画面のDeepLink生成
                var appDeepLink = "ainztulpeapp://notificationDetail/q_" + notificationId + "/NotificationListScreen";
                // アプリホーム画面へ遷移
                window.location.href = appDeepLink;
            }
            else {
                // notificationIdが取得出来なかった場合
                _this.errorMessage = '失敗';
                console.log('can not get notificationId');
            }
        });
    };
    return QuestantRedirectComponent;
}());
export { QuestantRedirectComponent };
